import r from "react";
var d = function(n) {
  var e = n.children, o = n.maxChildren, a = n.componentName, i = n.additionalInfo;
  if (!(!e || !o) && r.Children.count(e) > o)
    throw new Error(a + " component can have a maximum of " + o + " children. " + i);
};
export {
  d as c
};
